/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import Worker from './bulkFileUploader.worker'
import WorkerBuilder from './woker-builder'

export default function workersRegistration() {
  const bulkFileUploaderWebWorker = new WorkerBuilder(Worker)

  ;(navigator as any).bulkFileUploaderWebWorker = bulkFileUploaderWebWorker
}
